import React from 'react';
import PropTypes from 'prop-types';
import RequiredQuestionTypeComponent from './RequiredQuestionTypeComponent';

function RequiredQuestionTypeComponentList({ questions, prePopulate }) {
  return questions.map((question) => {
    const { questionId } = question;
    const { value } = prePopulate[questionId] || {};
    return (
      <RequiredQuestionTypeComponent
        key={questionId}
        question={question}
        prePopulatedValue={value || ''}
      />
    );
  });
}

RequiredQuestionTypeComponentList.propTypes = {
  questions: PropTypes.array.isRequired,
  prePopulate: PropTypes.object.isRequired,
};

export default RequiredQuestionTypeComponentList;
